import { Suspense, ReactNode, useState } from "react";
import { Await } from "react-router";

// Caches the first version of the promise given to only await once
// Use key={} on this to make it re-render
export const AwaitOnce = <T,>({
	resolve,
	fallback,
	children,
}: {
	resolve: () => Promise<T>;
	fallback: ReactNode;
	children: ReactNode | ((arg: T) => ReactNode);
}) => {
	const [promise] = useState(resolve);

	return (
		<Suspense fallback={fallback}>
			<Await resolve={promise}>{children}</Await>
		</Suspense>
	);
};
